query GetQuotaTemplate {
    quotasTemplate {
        csvContent
    }
}
